import React, { ChangeEvent, FC } from 'react';

import styled from 'styled-components';

import { Box, BoxProps } from '@mui/material';

import { themes } from '~/consts/experiences';

import { Spacing, margin, padding } from '../../helpers';

type InputProps = {
  id?: string;
  name?: string;
  value?: string | number | ReadonlyArray<string> | undefined;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
};

export const FieldWrapper = styled((props: BoxProps & Spacing) => <Box component="div" {...props} />)`
  position: relative;

  > input:focus-visible {
    outline: none !important;
    border: 1px solid ${themes?.primaryBlue};
  }

  margin: ${({ m, mx, my, mt, mb, ml, mr }) => margin({ m, mx, my, mt, mb, ml, mr })};

  padding: ${({ p, px, py, pt, pb, pl, pr }) => padding({ p, px, py, pt, pb, pl, pr })};
` as FC<BoxProps & Spacing>;

// TODO: Replace by FormControlLabel
export const Label = styled((props: any) => <label {...props} />)`
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 0 8px;
  line-height: 18px;
  text-transform: capitalize;
  color: ${themes?.primaryDark};
` as FC<any>;

// TODO: Replace by TextField
export const Field = styled.input<InputProps>`
  width: 100%;
  height: 35px;
  font-size: 14px;
  min-width: 105px;
  padding: 0px 10px;
  border-radius: 10px;

  color: ${({ disabled }) => disabled && themes.secondaryGrey};
  cursor: ${({ disabled }) => disabled && 'not-allowed !important'};

  border: 1px solid ${({ disabled }) => (disabled ? themes.disabled : themes?.primaryGrey)};

  ::placeholder {
    color: ${({ disabled }) => disabled && themes.disabled};
  }
` as FC<InputProps>;

// TODO: Replace by TextArea
export const FieldArea = styled.textarea<InputProps>`
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border-radius: 10px;

  cursor: ${({ disabled }) => disabled && 'not-allowed !important'};
  color: ${({ disabled }) => disabled && themes.disabled};

  border: 1px solid ${({ disabled }) => (disabled ? themes.disabled : themes?.primaryGrey)};

  ::placeholder {
    color: ${({ disabled }) => disabled && themes.disabled};
  }
` as FC<InputProps>;

// TODO: Replace by TextField
export const FieldSearch = styled.input<InputProps>`
  width: 100%;
  height: 34px;
  font-size: 14px;
  padding: 0px 10px;
  border-radius: 10px;

  cursor: ${({ disabled }) => disabled && 'not-allowed !important'};
  color: ${({ disabled }) => disabled && themes.secondaryGrey};

  border: 1px solid ${({ disabled }) => (disabled ? themes.disabled : themes?.primaryGrey)};

  ::placeholder {
    color: ${({ disabled }) => disabled && themes.disabled};
  }
` as FC<InputProps>;

export const OptionsWrapper = styled((props: BoxProps) => <Box component="div" {...props} />)`
  z-index: 9;
  width: 100%;
  padding: 12px 0;
  max-height: 200px;
  overflow-y: scroll;
  position: absolute;
  border-radius: 8px;
  background-color: ${themes?.white};
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);

  > .center {
    width: 100%;
    text-align: center;
  }

  > div {
    cursor: pointer;
    font-size: 14px;
    padding: 8px 16px;
    line-height: 18px;
    color: ${themes?.primaryDark};

    :hover {
      background-color: ${themes?.primaryLight};
    }
  }
` as FC<BoxProps>;
